import { View } from "react-native";
import { styledRN } from "./styled";
export const Row = styledRN(View, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
});
/**
 * (L | C | R)(Column | Row)(Gap)
 */
/**
 * Left Column with 10px gap
 */
export const LColumn10 = styledRN(View, {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: 10,
});
/**
 * Left Column with 20px gap
 */
export const LColumn20 = styledRN(View, {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: 20,
});
const Flex = styledRN(View, ({ $direction, $align, $justify, $gap }) => ({
    flexDirection: $direction,
    alignItems: $align === "start" ? "flex-start" : $align === "center" ? "center" : "flex-end",
    gap: $gap,
    justifyContent: $justify === "start" ? "flex-start" : $justify === "end" ? "flex-end" : "center",
}));
export const Structure = {
    Row,
    LColumn10,
    LColumn20,
    Flex
};
